<template>
  <div class="dialog-wrap">
    <el-dialog title="选择老师"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open"
               width="680px">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="老师姓名"
                      prop="name_keyword"
                      width="80">
          <el-input v-model="query.name_keyword "
                    placeholder="请输入"
                    style="width:150px"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号"
                      prop="phone_number_keyword ">
          <el-input v-model="query.phone_number_keyword "
                    placeholder="请输入"
                    style="width:150px"
                    clearable></el-input>
        </el-form-item>
        <el-button type="primary"
                   @click="fetchList()">搜索</el-button>
        <el-button @click="reset()">重置</el-button>
      </el-form>
      <el-table class="table"
                :data="results"
                border
                style="width: 100%"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="50"
                         align="center"> </el-table-column>
        <el-table-column prop="user_id"
                         width="100"
                         label="ID"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.user_id }}
          </template>
        </el-table-column>
        <el-table-column prop="name"
                         width="265"
                         label="老师姓名"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column prop="phone_number"
                         width="267"
                         label="手机号"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.phone_number }}
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <div></div>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template> 
 <script>
import { teacherList } from '@/api/course'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: null,
    },
  },
  watch: {
    visible(val) {
      // if (val) {
      console.log('取消', val)
      this.dialogVisible = val
      // }
    },
  },
  data() {
    return {
      dialogVisible: false,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 0,
      results: [],
      chooseList: [],
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleClose() {
      this.$emit('close')
      this.chooseList = []
    },
    open() {
      this.fetchList()
    },
    fetchList() {
      teacherList(this.query).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
        console.log('获取老师列表', res)
      })
    },
    reset() {
      this.query = {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        name_keyword: '',
        phone_number_keyword: '',
      }
      this.fetchList()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    handleSubmit() {
      if (this.type == 1) {
        this.$emit('submit', this.chooseList)
      }else {
         this.$emit('submits', this.chooseList)
      }

      this.handleClose()
    },
  },
}
</script>